import { useSavedLocationsApi } from "@/Hooks/useSavedLocationsApi";
import { useAuthentication } from "@/Slices/authenticationSlice";
import type { SavedLocation } from "@freightsimple/generated-dashboard-openapi-client/models/SavedLocation";
import { useOnce } from "@/Hooks/useOnce";
import { useState } from "react";

export function useLocationsSaved() {
  const { isAuthenticated } = useAuthentication();
  const savedLocationsApi = useSavedLocationsApi();
  const [loadingSavedLocations, setLoadingSavedLocations] = useState(true);
  const [savedLocationsLoadFailed, setSavedLocationsLoadFailed] =
    useState(false);

  const [savedLocations, setSavedLocations] = useState<Array<SavedLocation>>(
    [],
  );
  const [defaultPickupLocationId, setDefaultPickupLocationId] = useState<
    string | undefined
  >();
  const [defaultDeliveryLocationId, setDefaultDeliveryLocationId] = useState<
    string | undefined
  >();

  async function loadSavedLocations() {
    if (!isAuthenticated) {
      setLoadingSavedLocations(false);
      return;
    }

    setLoadingSavedLocations(true);
    setSavedLocationsLoadFailed(false);
    try {
      const savedLocationsResponse =
        await savedLocationsApi.getAllSavedLocations();

      const items = savedLocationsResponse.items;
      items.sort(function (a, b) {
        return a.location.businessName.localeCompare(b.location.businessName);
      });
      setSavedLocations(items);
      setDefaultPickupLocationId(
        savedLocationsResponse.defaultPickupLocationId,
      );
      setDefaultDeliveryLocationId(
        savedLocationsResponse.defaultDeliveryLocationId,
      );
    } catch (e) {
      console.warn("Error loading saved locations:", { e });
      setSavedLocationsLoadFailed(true);
    } finally {
      setLoadingSavedLocations(false);
    }
  }

  useOnce(async () => {
    await loadSavedLocations();
  });

  return {
    savedLocations,
    loadingSavedLocations,
    savedLocationsLoadFailed,
    reloadSavedLocations: loadSavedLocations,
    defaultPickupLocationId,
    defaultDeliveryLocationId,
  };
}
